import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { MessagesOutline24Icon } from 'assets/icons'
import { useMyNotificationCount } from 'src/graphql/hooks'

const IconMessageButton = ({ display, size }) => {
   const { notificationCount } = useMyNotificationCount()

   return (
      <View display={display}>
         <Link to="/messages">
            <View
               position="relative"
               width={size}
               height={size}>
               <MessagesOutline24Icon
                  width="100%"
                  height="100%"
                  strokeWidth="2px"
                  color="#888"
               />
               {notificationCount && (
                  <View
                     position="absolute"
                     top="-9px"
                     right="-12px"
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     width="18px"
                     height="18px"
                     borderRadius="50%"
                     marginLeft="9px"
                     backgroundColor="#ff5c45">
                     <Text size="0.85" color="#fff">
                        {notificationCount}
                     </Text>
                  </View>
               )}
            </View>
         </Link>
      </View>
   )
}

IconMessageButton.propTypes = {
   display: PropTypes.string,
   size: PropTypes.string.isRequired
}

IconMessageButton.defaultProps = {
   display: 'block'
}

export default IconMessageButton
